module.exports = __webpack_public_path__ + "img/icon_input_googlemap.208c14d.svg";